import './AdPage.css';
import { AD_CLIENT, AD_SLOT } from './pages/privacy/constants';

function AdPage() {
  return (
    <div className="ad-container">
      <amp-ad width="100vw" height="90"
        type="adsense"
        data-ad-client={AD_CLIENT}
        data-ad-slot={AD_SLOT}
        data-auto-format="rspv"
        data-full-width=""
        >
        <div overflow=""></div>
        <div fallback="true">No ad for you</div>
      </amp-ad>
    </div>
  );
}

export default AdPage;
